export default () => ({
	show_field: false,
	value: '',
	init() {
		this.$watch(
			'value',
			(value) => {
				if ( value.length < 3 ) {
					this.$dispatch( 'search', '');
				} else {
					this.$dispatch( 'search', value );
				}
			}
		);
	},
	clearSearch() {
		this.value = '';
	}
});
